<template>
  <v-form>
    <v-btn
      color="error"
      :style="{ 'text-transform': 'none' }"
      @click="callSaveChanges"
      :loading="isLoading"
    >
      {{ lang.delete }}
    </v-btn>
  </v-form>
</template>

<script>
export default {
  name: "vc-share-my-contents-delete",
  props: {
    locale: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => {
        return {
          confirm: "この作品を削除します。よろしいですか？",
          delete: "削除する"
        };
      }
    },
    contentsId: {
      type: Number,
      default: 0
    },
    contentsPublicationType: {
      type: String,
      default: "public"
    },
    deleteConfirmMessageSecureView: {
      type: String,
      default: ""
    },
    clientName: {
      type: String,
      default: ""
    },
    deleteContents: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      errorMessage: "",
      isLoading: false
    };
  },
  computed: {
    deleteConfirmMessage() {
      switch (this.contentsPublicationType) {
        case "public":
        default:
          return this.lang.confirm;
        case "secure_view":
          // replace() だと1つしか起き変わらず、全ての「:client_name」を置換するためsplit().join() を使用する
          return this.deleteConfirmMessageSecureView
            .split(":client_name")
            .join(this.clientName);
      }
    }
  },
  methods: {
    callSaveChanges: function() {
      if (!confirm(this.deleteConfirmMessage)) {
        return;
      }

      this.isLoading = true;

      let requestData = {
        contentsId: this.contentsId
      };

      this.deleteContents(requestData).then(value => {
        if (value === 0) {
          location.href = "/" + this.locale + "/my-contents";
        } else {
          this.isLoading = false;
        }
      });
    }
  }
};
</script>
